import { translate } from '../../../../../common/intl';
import { KendoDataGridShellColumn } from '../../../../components/KendoDataGrid/KendoDataGridShell';

interface ColumnDef {
  id: string
  title: string
  width?: number
}

interface EquipmentShellColumnOptions {
  isMPIProcedure?: boolean
  isLHRStep?: boolean
  isEBProcedure?: boolean
}

const MPI_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.equipment.grid.title' },
  { id: 'LHRTparameter', title: 'form.builder.procedure.lhrt.parameter.title', width: 150 },
];

const LHRT_COLUMNS: ColumnDef[] = [
  { id: 'title', title: 'form.builder.procedure.equipment.grid.title' },
];

const EB_COLUMNS: ColumnDef[] = [
  { id: 'plannedId', title: 'lhr.equipment.grid.heading.planned.id', width: 350 },
  { id: 'equipmentId', title: 'lhr.equipment.grid.heading.actual.id', width: 250 },
  { id: 'calDueDate', title: 'lhr.equipment.grid.heading.cal.due.date', width: 200 },
  { id: 'pmDueDate', title: 'lhr.equipment.grid.heading.pm.due.date', width: 200 },
];

const DEFAULT_COLUMNS: ColumnDef[] = [
  { id: 'plannedId', title: 'lhr.equipment.grid.heading.planned.id', width: 150 },
  { id: 'actualId', title: 'lhr.equipment.grid.heading.actual.id', width: 150 },
  { id: 'eqStatus', title: 'lhr.equipment.grid.heading.eq.status', width: 150 },
  { id: 'calDueDate', title: 'lhr.equipment.grid.heading.cal.due.date', width: 150 },
  { id: 'pmDueDate', title: 'lhr.equipment.grid.heading.pm.due.date', width: 150 },
];

const toShellColumns = (columns: ColumnDef[]): KendoDataGridShellColumn[] =>
  columns.map((column) => ({
    id: column.id,
    title: translate(column.title),
    width: column.width,
  }));

export const getEquipmentShellColumns = ({
  isMPIProcedure,
  isLHRStep,
  isEBProcedure,
}: EquipmentShellColumnOptions): KendoDataGridShellColumn[] => {
  if (isMPIProcedure && !isLHRStep) {
    return toShellColumns(MPI_COLUMNS);
  }
  if (isLHRStep) {
    return toShellColumns(LHRT_COLUMNS);
  }
  if (isEBProcedure) {
    return toShellColumns(EB_COLUMNS);
  }
  return toShellColumns(DEFAULT_COLUMNS);
};
